var map = {
	"./address.png": "16c1",
	"./core-value.png": "6f62",
	"./message.png": "18d4",
	"./milestones-en.png": "1a13",
	"./milestones.png": "4569",
	"./navigation.png": "e8c0",
	"./news-link.png": "f634",
	"./phone.png": "6b76",
	"./theme.png": "a0a3",
	"./user_name.png": "fda7",
	"./value-en.png": "b857",
	"./value.png": "25bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ae6";